import React from 'react'
import {Route, useParams} from 'react-router-dom'
import MainPageLayout from '../../layout/MainPageLayout'

const MainLayoutRoute = ({path, exact, component: Component, ...rest}: {
	path: string,
	exact?: boolean,
	component?: any,
	rest?: any
}) =>
{
	const params = useParams()
	const matchProps = {match: {params}}
	return (
		<MainPageLayout>
			<Component {...matchProps} />
		</MainPageLayout>
	)
}

export default MainLayoutRoute
